<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 170px"
            v-model="filters.name"
            placeholder="请输入订单名称"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
      <el-table-column
        prop="name"
        label="项目名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column
        prop="code"
        label="订单编号"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="provinceName"
        label="省"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="市"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="districtName"
        label="县"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop=""
        label="合作时间"
        align="center"
        show-overflow-tooltip
        width="300"
      >
        <template #default="scope">
          <span>{{ scope.row.startTime }}</span
          >--
          <span>{{ scope.row.endTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isWatchMainPermission"
        label="主体视频观看权限"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isWatchMainPermission == true"
            >有</el-tag
          >
          <el-tag type="warning" v-if="scope.row.isWatchMainPermission == false"
            >无</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="主体视频下载权限"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isLoadMainPermission == true"
            >有</el-tag
          >
          <el-tag type="warning" v-if="scope.row.isLoadMainPermission == false"
            >无</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="附件下载权限"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag
            type="success"
            v-if="scope.row.isLoadAccessoryPermission == true"
            >有</el-tag
          >
          <el-tag
            type="warning"
            v-if="scope.row.isLoadAccessoryPermission == false"
            >无</el-tag
          >
        </template></el-table-column
      >
      <el-table-column
        prop="amount"
        label="金额(元)"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="totalUserCount"
        label="总用户量"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isEnable"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isEnable == true">启用</el-tag>
          <el-tag type="info" v-if="scope.row.isEnable == false">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        show-overflow-tooltip
        width="240"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="320" align="center">
        <template slot-scope="scope">
          <el-button
            @click="enableBtnFun(scope.row)"
            type="text"
            size="small"
            >{{ scope.row.isEnable ? "禁用" : "启用" }}</el-button
          >
          <el-button
            @click="viewOrderProductPromotionDetail(scope.row)"
            type="text"
            size="small"
            >查看明细</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="getAreaOrderWeeklyReport(scope.row)"
            >获取区域订单周报</el-button
          >
	        <el-button
			        type="text"
			        size="small"
			        @click="viewStatisticalAnalysisDetail(scope.row)"
	        >统计分析</el-button
	        >
        </template>
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--订单新增区域新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <div class="left" style="flex: 1">
          <el-form
            :model="Form"
            label-width="100px"
            ref="Form"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="项目名称：" prop="name">
              <el-input
                v-model="Form.name"
                auto-complete="off"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>

            <el-form-item label="选择地区: ">
              <el-form-item
                style="display: inline-block"
                label="省份："
                prop="provinceId"
              >
                <el-select
                  style="width: 100px"
                  clearable
                  v-model="Form.provinceId"
                  placeholder="请选择"
                  @change="handleProvinceChange"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                style="display: inline-block"
                label="城市:"
                prop="cityId"
              >
                <el-select
                  style="width: 100px"
                  clearable
                  v-model="Form.cityId"
                  placeholder="请选择"
                  @change="handleCityChange"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                style="display: inline-block"
                label="区县："
                prop="districtId"
              >
                <el-select
                  style="width: 100px"
                  clearable
                  v-model="Form.districtId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
            <el-form-item label="合作期限:" prop="serachTimer">
              <el-date-picker
                v-model="Form.serachTimer"
                :unlink-panels="true"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="金额(元)：" prop="amount">
              <el-input
                v-model="Form.amount"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="权限：">
              <el-checkbox
                v-model="Form.isWatchMainPermission"
                label="主体视频观看权限"
              ></el-checkbox>
              <el-checkbox
                v-model="Form.isLoadMainPermission"
                label="主体视频下载权限"
              ></el-checkbox>
              <el-checkbox
                v-model="Form.isLoadAccessoryPermission"
                label="附件下载权限"
              ></el-checkbox>
            </el-form-item>
            <el-form-item label="管理员列表">
              <div
                v-for="(admin, index) in Form.admins"
                :key="index"
                style="margin-bottom: 20px; display: flex; align-items: center"
              >
                <!-- 姓名 -->
                <el-form-item
                  :prop="'admins.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: '姓名不能为空',
                    trigger: 'blur',
                  }"
                 
                  style="margin-bottom: 0; margin-right: 10px; width: 200px"
                >
                  <el-input v-model="admin.name" placeholder="姓名"></el-input>
                </el-form-item>
                <!-- 手机号 -->
                <el-form-item
                  :prop="'admins.' + index + '.phoneNumber'"
                  :rules="[
                    {
                      required: true,
                      message: '手机号不能为空',
                      trigger: 'blur',
                    },
                    {
                      pattern: /^1[3-9]\d{9}$/,
                      message: '格式错误',
                      trigger: 'blur',
                    },
                  ]"
                  style="margin-bottom: 0; margin-right: 10px; width: 200px"
                >
                  <el-input
                    v-model="admin.phoneNumber"
                    placeholder="手机号"
                  ></el-input>
                </el-form-item>

                <!-- 删除按钮 -->
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                  @click="removeAdmin(index)"
                ></el-button>
              </div>

              <!-- 添加按钮 -->
              <el-button
                type="primary"
                size="small"
                @click="addAdmin"
                icon="el-icon-plus"
                >添加管理员</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--区域订单周报-->
    <el-dialog
      title="区域订单周报"
      :visible.sync="ReportVisable"
      v-model="ReportVisable"
      :close-on-click-modal="false"
    >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="周报" name="first"></el-tab-pane>
      <el-tab-pane label="月报" name="second"></el-tab-pane>
    </el-tabs>
      <el-table
        :data="orderProductPromotionReportData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        border
        class="custom-padding-table"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
          show-overflow-tooltip
          width="50"
        >
        </el-table-column>
         <el-table-column
          prop="code"
          label="唯一标识"
          align="center"
          show-overflow-tooltip
          width="300"
        >
        <template #default="scope">
            <span style="color:#409EFF;cursor:pointer;"  @click="getOrderProductPromotionReport(scope.row)"> {{scope.row.code}}</span>
          </template>
        </el-table-column>
    
         <el-table-column
          prop="reportName"
          label="报告名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
         <el-table-column
          prop="reportAbstract"
          label="报告摘要"
          align="center"
          show-overflow-tooltip
          
        >
        </el-table-column>
         <el-table-column
          prop="reportStartTime"
          label="报告计算开始日期"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
          <el-table-column
          prop="reportEndTime"
          label="报告计算结束日期"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
         </el-table-column>
          <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </el-dialog>
     <!--新增预览弹窗 -->
    <el-dialog
      title="文件预览"
      :visible.sync="previewDialogVisible"
      width="80%"
      top="5vh"
      custom-class="pdf-preview-dialog"
      @close="closePreview"
    >
      <!-- 核心：使用 iframe 展示 FileUrl -->
      <!-- v-if 确保每次打开都重新加载 iframe，避免缓存问题 -->
      <div v-if="previewDialogVisible" class="iframe-container">
        <iframe
          :src="previewUrl"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getAreaDictionaryList,
  editOrderProductPromotionListPageApi,
  getOrderProductPromotionListPageApi,
  addOrderProductPromotionListPageApi,
  delOrderProductPromotionListPageApi,
  isEnablelOrderProductPromotionApi,
  getOrderProductPromotionReportDataApi
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      time: "",
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        name: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      provinceOptions: [],
      cityOptions: [],
      areaOptions: [],
      pid: 0,
      FormVisible: false,
      Form: {
        name: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        serachTimer: "",
        amount: "",
        isWatchMainPermission: false,
        isLoadMainPermission: false,
        isLoadAccessoryPermission: false,
        admins: [
         
        ],
      },

      FormRules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        provinceId: [
          { required: true, message: "请选择省份", trigger: "blur" },
        ],
        cityId: [{ required: true, message: "请选择城市", trigger: "blur" }],
        districtId: [
          { required: true, message: "请选择区县", trigger: "blur" },
        ],
        serachTimer: [
          { required: true, message: "请选择合作期限", trigger: "blur" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
      },
      currentRow: "",
      editmark: false,
      orderProductPromotionReportData: [],
      ReportVisable: false,
      activeName:"first",
      reportType:1,
      previewDialogVisible:false,
      previewUrl:''

    };
  },
  methods: {
    addAdmin() {
      this.Form.admins.push({
        name: "",
        phoneNumber: "",
      });
    },
    removeAdmin(index) {
      this.Form.admins.splice(index, 1);
    },
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    enableBtnFun(row) {
      let isEnable = !row.isEnable;
      let params = {
        id: row.id,
        isEnable: isEnable,
      };
      isEnablelOrderProductPromotionApi(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.message);
          this.getList();
        }
      });
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getOrderProductPromotionListPageApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },
    selectCurrentRow(row) {
      this.currentRow = row;
    },
    async handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.editmark = true;
      this.Form = {
        name: this.currentRow.name,
        provinceId: this.currentRow.provinceId,
        cityId: this.currentRow.cityId,
        districtId: this.currentRow.districtId,
        serachTimer: [this.currentRow.startTime, this.currentRow.endTime],
        amount: this.currentRow.amount,
        isWatchMainPermission: this.currentRow.isWatchMainPermission,
        isLoadMainPermission: this.currentRow.isLoadMainPermission,
        isLoadAccessoryPermission: this.currentRow.isLoadAccessoryPermission,
        admins: this.currentRow.admins?this.currentRow.admins : []
      };
      
      // 根据省份获取一下城市列表
      this.pid = this.Form.provinceId;
      await this.getProvinceCityInfo(1);
      // 根据城市列表获取一下区县列表
      this.pid = this.Form.cityId;
      await this.getProvinceCityInfo(2);
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });

      this.Form = {
        name: "",
        provinceId: "",
        cityId: "",
        districtId: "",
        serachTimer: "",
        amount: "",
        isWatchMainPermission: false,
        isLoadMainPermission: false,
        isLoadAccessoryPermission: false,
        admins: [
          
        ],
      };
      this.cityOptions = [];
      this.areaOptions = [];
      this.editmark = false;
      this.FormVisible = true;
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        this.listLoading = true;
        let params = {
          id: this.currentRow.id,
        };

        delOrderProductPromotionListPageApi(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
            const currentPageSize = this.tableData.length;
            if (currentPageSize === 1 && this.pages.pageIndex > 1) {
            this.pages.pageIndex--;
            }
            this.getList();
            this.$refs["Form"].clearValidate();
            this.FormVisible = false;
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            const { serachTimer, ...restForm } = this.Form;

            let params = {
              ...restForm,
              id: this.currentRow ? this.currentRow.id : "",
              startTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[0])
                : "",
              endTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[1])
                : "",
            };
            if (this.editmark) {
              editOrderProductPromotionListPageApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.getList();
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addOrderProductPromotionListPageApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    // 当省份改变时重新获取城市
    handleProvinceChange(val) {
      this.Form.cityId = "";
      this.Form.districtId = "";
      this.pid = val;
      this.getProvinceCityInfo(1);
    },
    // 当城市改变时获取区县
    handleCityChange(val) {
      this.Form.districtId = "";
      this.pid = val;
      this.getProvinceCityInfo(2);
    },
    // 获取省市接口
    getProvinceCityInfo(type) {
      var params = {
        pid: this.pid,
      };
      return getAreaDictionaryList(params).then((res) => {
        if (type == 0) {
          this.provinceOptions = res.data.response;
        } else if (type == 1) {
          this.cityOptions = res.data.response;
        } else if (type == 2) {
          this.areaOptions = res.data.response;
        }
      });
    },

    viewOrderProductPromotionDetail(row) {
      this.$router.push({
        path: "/OrderProductPromotionDetail",
        query: { id: row.id },
      });
    },
	  viewStatisticalAnalysisDetail(row) {
		  this.$router.push({
			  path: "/statisticalAnalysis",
			  query: { id: row.id },
		  });
	  },
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
    handleClick(e){
      if(e.name=="first"){
        this.reportType =1;
      }else{
        this.reportType =2;
      }   
      this.getAreaOrderWeeklyReport(this.currentRow)
    },
    getAreaOrderWeeklyReport(row) {
      let params = {
        orderProductPromotionId: row.id,
        reportType:this.reportType
      };
      getOrderProductPromotionReportDataApi(params).then((res) => {
        if (res.data.success) {
          this.orderProductPromotionReportData = res.data.response;
          this.ReportVisable = true;
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    getOrderProductPromotionReport(row){
      
        const baseUrl = window.location.origin; 
        let allUrl = baseUrl + '/qmxfwebapi/obs/getOrderProductPromotionReport/' +  row.code
        console.log('allUrl',allUrl)
        const fileExtension = row.reportName.split('.').pop().toLowerCase();
        if (fileExtension === 'docx') {
          console.log('allUrl',allUrl)
          this.previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(allUrl)}`;
        }
        this.previewDialogVisible = true; 
    },
    closePreview() {
      this.previewUrl = '';
    },
  },
  mounted() {
    this.getList();
    this.getProvinceCityInfo(0);
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.pageBar {
  margin-top: 15px;
}
  /* 限制 iframe 容器的高度，防止撑破屏幕 */
.iframe-container {
  width: 100%;
  height: 70vh; /* 占据视口高度的 70% */
  background-color: #f0f2f5; /* 灰色背景，突出文档 */
}

iframe {
  display: block;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table {
  ::v-deep .el-table__cell {
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}

/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
